import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ILocation } from "../../utils/types/models";

export default createEntityReducer<ILocation>(Endpoint.Locations, Endpoint.CustomerLocationsList);
